export default __webpack_public_path__ + "static/media/cancel.e2f346ec.svg";